export const COVER_TYPE = {
    personalCover: "personalCover"
}

const COMMON_ROADSIDE_PROPS = {
    description_shortened:
        "24/7 roadside assistance (over 1/4 mile away from home).",
    label: "Roadside Assistance",
    modal: false,
    free: false,
};

const COMMON_VEHICLE_PROPS = {
    label: "Vehicles",
    description: "Number of vehicles covered.",
    min: 1,
    max: window?.package?.max_vehicles ?? 10,
};

const COMMON_REMOVABLE_PROPS = {
    value: null, // 0
    modal: false,
    free: false,
    hideWhenSelected: true,
    removable: true,
};

const COMMON_LOCAL_PROPS = {
    question:
        "Alternatively would you like us to take you to a local destination of your choice within 10 miles?",
    label: "Local Recovery",
    disabled: true,
    description:
        "We'll recover your vehicle to a safe place or repair centre of your choice within 10 miles of the location.",
    options: [
        {
            label: "Yes, add Local Recovery",
            value: 1,
        },
        {
            label: "No thanks",
            value: 0,
        },
    ],
    optionsToggle: [
        {
            label: "Add Local Recovery",
            value: 1,
        },
        {
            label: "No thanks",
            value: 0,
        },
    ],
    value: 1, // included as standard
    modal: false,
    free: false,
};

const COMMON_NATIONWIDE_PROPS = {
    question:
        "We fix 80% of vehicles at the roadside, if we can't, would you like us to take you to any UK destination of your choice?",
    label: "Nationwide Recovery",
    description:
        "If we can't fix your vehicle at the roadside, we'll tow it along with you and your passengers to any UK mainland destination.",
    options: [
        {
            label: "Yes, add National Recovery",
            value: 1,
            dusk: "national-recovery-option",
            svg: 'nationwide-xl'
        },
        {
            label: "No thanks",
            value: 0,
            dusk: "no-thanks-2-option",
            svg: 'cross-black'
        },
    ],
    optionsToggle: [
        {
            label: "No thanks",
            value: 0,
            dusk: "nationwide-no-thanks-option",
        },
        {
            label: "Add National Recovery",
            value: 1,
            dusk: "nationwide-add-option",
        },
    ],
    splitTestStep: 'nationwide_q'
};

const COMMON_PERSONAL_PROPS = {
    question:
        "Would you like to add personal cover, which covers you as a driver in any vehicle (not just your own)?",
    label: "Personal Cover",
    description:
        "Your level of breakdown cover will extend to any vehicle you are driving.",
    options: [
        {
            label: "Yes, add Personal Cover",
            value: 1,
        },
        {
            label: "No thanks",
            value: 0,
        },
    ],
    value: null, // 0
    modal: false,
    free: false,
};

const COMMON_ONWARDS_PROPS = {
    question: "Onward Travel",
    label: "Onward Travel",
    description:
        "We'll arrange the reimbursement of alternative transport or a hotel room for you and your passengers.",
    optionsToggle: [
        {
            label: "No thanks",
            value: 0,
            dusk: "onward-no-thanks-option",
        },
        {
            label: "Add Onward Travel",
            value: 1,
            dusk: "onward-add-option",
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_MISFUEL_PROPS = {
    question: "Misfuel Assistance",
    label: "Misfuel Assistance",
    description:
        "We'll arrange to have a fuel draining expert turn out to the location or recover your vehicle to a misfuel repair centre.",
    optionsToggle: [
        {
            label: "No thanks",
            value: 0,
            dusk: "misfuel-no-thanks-option",
        },
        {
            label: "Add Misfuel Assistance",
            value: 1,
            dusk: "misfuel-add-option",
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_EXCESS_PROPS = {
    question: "Reduce your price by 50% with a £50 excess",
    description:
        "Reduce your annual fee by 50% by adding a £50 call out charge to your membership.",
    label: "Excess",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: 0, // not offered as addon effective Jul 22
    modal: false,
    free: false,
};

const COMMON_ACCIDENT_PROPS = {
    question: "Accident Assistance - <em>Included As Standard</em>",
    description: "We will recover your vehicle when it's been in an accident.",
    label: "Accident Assistance",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: 1, // included as standard
    modal: false,
    free: false,
};

const COMMON_UNLIMITED_PROPS = {
    question: "Unlimited Callouts - <em>Included As Standard</em>",
    description:
        (typeof window !== "undefined" && window.excessWording) ? "Call us out as many times as you need to, as long as it's not a recurring problem with your vehicle. <b class=\"font-semibold\">There's no excess to pay on callouts</b> - unlike some providers, we don't charge an excess fee per callout." : "Call us out as many times as you need to, as long as it's not a recurring problem with your vehicle.",
    label: "Unlimited Callouts",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: 1, // included as standard
    modal: false,
    free: false,
};

const COMMON_EUROPEAN_PROPS = {
    question: "European Cover",
    description:
        "Get peace of mind when travelling abroad, we now cover 20 European Countries. See our membership terms for more detail.",
    label: "European Cover",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_ACCIDENT_PLUS_PROPS = {
    question: "Accident Assistance Plus",
    description:
        "Our expert accident management that will save you time, money and hassle. 24/7 Accident Assistance. Excess Cover & Free Fuel.",
    label: "Accident Assistance Plus",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: [
        {
            title: "24/7 Accident Assistance",
            description:
                "We'll manage your claim for free. We’ll even save you money on your insurance excess. On average, our clients save £348. So if you're ever in an accident, you'll be glad you were a member.",
        },
        {
            title: "Excess Cover",
            description:
                "We'll cover any excess cost that your insurer would usually charge you following an accident as long as we're dealing with your claim. We save our clients on avg £348, no excess, no problem.",
        },
        {
            title: "Free Fuel",
            description:
                "Our free £150 fuel card will get your like-for-like replacement vehicle up and running, while your vehicle is being repaired.",
        },
    ],
};

const COMMON_PARTS_LABOUR_PROPS = {
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    modal: false,
    free: false,
};

const COMMON_CARAVAN_TRAILER_PROPS = {
    question: "Caravan and Trailer Cover",
    description:
        "Nationwide recovery for your caravan and trailer cover to a weight limit of 3 tonnes and size limits of 7 metres long, 3 metres high and 2.55 metres wide.",
    label: "Caravan and Trailer Cover",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_KEY_PROPS = {
    question: "Key Assistance",
    description:
        "Our team are on hand to offer assistance if you damage or lose your keys, we'll recover you and your vehicle to your home address or to a local garage.",
    label: "Key Assistance",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_BATTERY_PROPS = {
    question: "Battery Replace",
    description:
        'With Battery Replace, we\'ll replace the battery following a breakdown if required. Saving you £160 on average. <br><small class="block text-xs italic mt-2 leading-5 md:leading-4">If you have a flat battery, we’ll always help you even without Battery Replace.</small>',
    label: "Battery Replace",
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const COMMON_TYRE_PROPS = {
    options: [
        {
            label: "Yes",
            value: 1,
        },
        {
            label: "No",
            value: 0,
        },
    ],
    value: null,
    modal: false,
    free: false,
};

const OPTIONS_TOGGLE = {
    personal: {
        home: [
            {
                label: "Add Cover at Home",
                value: 1,
                dusk: "home-cover-add-option",
            },
            {
                label: "No thanks",
                value: 0,
                dusk: "home-cover-no-thanks-option",
            },
        ],
        people_form: [
            {
                label: 'Single',
                value: 1,
                dusk: 'single-person-option',
                svg: 'onePerson'
            },
            {
                label: 'Joint',
                value: 2,
                dusk: 'joint-cover-option',
                svg:'twoPeople'
            },
            {
                label: 'Family <span class="block subtitle text-xs text-left">Up to 4</span>',
                value: 3, //'showFamilyOptions',
                dusk: 'family-cover-option',
                svg:'threePeople'
            },
        ],
    },
    business: {
        home: [
            {
                label: "Add “Home Start”",
                value: 1,
                dusk: "home-cover-add-option",
                svg: 'nationwide-xl'
            },
            {
                label: "No thanks",
                value: 0,
                dusk: "home-cover-no-thanks-option",
                svg: 'cross-black'
            },
        ],
    },
};

const OTHER_OPTIONS_OBJECT = {
    personal: {
        vehicle: [
            {
                label: "One",
                value: 1,
                price: 900,
                dusk: "one-vehicle-option",
                svg: 'car',
            },
            {
                label: "Two",
                value: 2,
                price: 1800,
                dusk: "two-vehicle-option",
                svg: 'car',
            },
            {
                label: "Three",
                value: 3,
                price: null,
                dusk: "three-vehicle-option",
                svg: 'car',
            },
            {
                label: "Four or more",
                value: 4,
                price: null,
                dusk: "four-vehicle-option",
                svg: 'car',
            },
        ],
        home: [
            {
                label: "Yes, add Cover at Home",
                value: 1,
                dusk: "home-cover-option",
                svg: 'home'
            },
            {
                label: "No thanks",
                value: 0,
                dusk: "no-thanks-1-option",
                svg: 'cross-black'
            },
        ],
    },
    business: {
        vehicle: [
            {
                label: "One",
                value: 1,
                dusk: "one-vehicle-option",
                svg: 'car',
            },
            {
                label: "Two",
                value: 2,
                dusk: "two-vehicle-option",
                svg: 'car',
            },
            {
                label: "Three",
                value: 3,
                price: null,
                dusk: "three-vehicle-option",
                svg: 'car',
            },
            {
                label: "Four",
                value: 4,
                price: null,
                dusk: "four-vehicle-option",
                svg: 'car',
            },

            {
                label: "Five",
                value: 5,
                price: null,
                svg: 'car',
            },
            {
                label: "Six or more",
                value: "showFullOptions",
                price: null,
                svg: 'car',
            },
        ],
        home: [
            {
                label: "Yes, add “Home Start”",
                value: 1,
                dusk: "home-cover-option",
                svg: 'home'
            },
            {
                label: "No thanks",
                value: 0,
                dusk: "no-thanks-1-option",
                svg: 'cross-black'
            },
        ],
    },
};

const FULL_FAMILY_OPTIONS = [
    {
        label: "3 People",
        value: 3,
        svg:'personal'
    },
    {
        label: "4 People",
        value: 4,
        svg:'personal'
    },
    {
        label: "5 People",
        value: 5,
        svg:'personal'
    },
]

const FULL_OPTIONS_VEHICLE = {
    business: [
        {
            label: "One",
            value: 1,
            svg: 'car',
        },
        {
            label: "Two",
            value: 2,
            svg: 'car',
        },
        {
            label: "Three",
            value: 3,
            price: null,
            svg: 'car',
        },
        {
            label: "Four",
            value: 4,
            price: null,
            svg: 'car',
        },

        {
            label: "Five",
            value: 5,
            price: null,
            svg: 'car',
        },
        {
            label: "Six",
            value: 6,
            price: null,
            svg: 'car',
        },

        {
            label: "Seven",
            value: 7,
            price: null,
            svg: 'car',
        },

        {
            label: "Eight",
            value: 8,
            price: null,
            svg: 'car',
        },

        {
            label: "Nine",
            value: 9,
            price: null,
            svg: 'car',
        },

        {
            label: "Ten",
            value: 10,
            price: null,
            svg: 'car',
        },
        {
            label: "Over ten",
            value: 11,
            price: null,
            svg: 'car',
        },
    ],
};

export const PERSONAL_ROADSIDE_FORM = {
    cover_type: {
        question: "What type of cover are you looking for?",
        options : [
            {
                label: 'Vehicle Cover',
                value: 'vehicleCover',
                svg: 'car',
                slug: "bespoke-monthly",
                subtitle: 'Cover for one or multiple vehicles, whoever\'s driving'
            },
            {
                label: 'Personal Cover',
                value: 'personalCover',
                svg: 'onePerson',
                slug: "personal-bespoke-monthly",
                subtitle: 'Cover for you or your family while driving any vehicle'
            }
        ],
        value: null,
        slug: null,
        splitTestStep: 'which_cover_q'
    },
    people_form: {
        question: 'How many people do you need cover for?',
        label: 'Peoples',
        description: 'Number of people covered',
        min: 1,
        max: 5,
        options: OPTIONS_TOGGLE.personal.people_form,
        fullOptions: FULL_FAMILY_OPTIONS,
        value: null,
        lookedUp: false,
        splitTestStep: 'personal_q'
    },
    roadside: {
        ...COMMON_ROADSIDE_PROPS,
        description: "24/7 roadside assistance (over 1/4 mile away from home).",
        value: 1,
    },
    vehicle: {
        ...COMMON_VEHICLE_PROPS,
        question: "How many vehicles do you need breakdown cover for?",
        options: OTHER_OPTIONS_OBJECT.personal.vehicle,
        value: null,
        lookedUp: false,
        splitTestStep: 'vehicle_q'
    },
    home: {
        ...COMMON_REMOVABLE_PROPS,
        label: "Home Start",
        question: "If you breakdown at home, would you like us to help?",
        description:
            "Our cover starts when you're 1/4 mile from home, if you want cover on your driveway don't forget to add this.",
        descriptionCover:
            "Cover from your doorstep or driveway. Without this, cover starts 1/4 mile from your home address",
        options: OTHER_OPTIONS_OBJECT.personal.home,
        optionsToggle: OPTIONS_TOGGLE.personal.home,
        splitTestStep: 'home_q'
    },
    nationwide: {
        ...COMMON_REMOVABLE_PROPS,
        ...COMMON_NATIONWIDE_PROPS,
    },
    local: {
        ...COMMON_LOCAL_PROPS,
    },
    personal: {
        ...COMMON_PERSONAL_PROPS,
        optionsToggle: [
            {
                label: 'No thanks',
                value: 0,
                dusk: 'personal-no-thanks-option',
            },
            {
                label: 'Add Personal Cover',
                value: 1,
                dusk: 'personal-add-option',
            },
         
        ],
    },
    onward: {
        ...COMMON_ONWARDS_PROPS,
        options: [
            {
                label: 'Yes, add Onward Travel',
                value: 1,
            },
            {
                label: 'No thanks',
                value: 0,
            },
        ],
    },
    misfuel: {
        ...COMMON_MISFUEL_PROPS,
        options: [
            {
                label: 'Yes, add Misfuel Assistance',
                value: 1,
            },
            {
                label: 'No thanks',
                value: 0,
            },
        ],
    },
    excess: {
        ...COMMON_EXCESS_PROPS,
    },
    accident: {
        ...COMMON_ACCIDENT_PROPS,
    },
    unlimited: {
        ...COMMON_UNLIMITED_PROPS,
    },
    european: {
        ...COMMON_EUROPEAN_PROPS,
    },
    accident_plus: {
        ...COMMON_ACCIDENT_PLUS_PROPS,
    },
    parts_labour: {
        question: "Parts and Garage Cover",
        description:
            "We'll cover up to £1500 and 3 claims a year towards your repair bill - giving you total peace of mind!",
        extrasInfo: "",
        label: "Parts and Garage Cover",
        value: 0,
        optionsToggle: [
            {
                label: 'Add Parts and Garage',
                value: 1,
            },
            {
                label: 'No thanks',
                value: 0,
            },
        ],
        ...COMMON_PARTS_LABOUR_PROPS,
    },
    caravan_trailer: {
        ...COMMON_CARAVAN_TRAILER_PROPS,
    },
    key: { 
        ...COMMON_KEY_PROPS 
    },
    battery: {
        optionsToggle: [
            {
                label: "No thanks",
                value: 0,
                dusk: "battery-no-thanks-option",
            },
            {
                label: "Add Battery Replace",
                value: 1,
                dusk: "battery-add-option",
            },
        ],
        ...COMMON_BATTERY_PROPS,
    },
    tyre: {
        question: "Tyre Replace",
        description: "A new tyre costs £130 on average. With Tyre Replace, we'll repair or replace up to 3 tyres if yours are punctured or damaged. <br><small class=\"block text-xs italic mt-2 leading-5 md:leading-4\">If you have a puncture, we’ll always help you even without Tyre Replace.</small>",
        label: 'Tyre Replace',
        optionsToggle: [
            {
                label: "No thanks",
                value: 0,
                dusk: "tyre-no-thanks-option",
            },
            {
                label: "Add Tyre Replace",
                value: 1,
                dusk: "tyre-add-option",
            },
        ],
        ...COMMON_TYRE_PROPS,
    },
};

export const BUSINESS_ROADSIDE_FORM = {
    roadside: {
        ...COMMON_ROADSIDE_PROPS,
        description: '24/7 roadside assistance (over 1/4 mile away from your registered office address) - this is included as standard in your membership.',
        value: null,
    },
    vehicle: {
        ...COMMON_VEHICLE_PROPS,
        question:
            "We cover the vehicle regardless of who's driving. How many vehicles do you need cover for?",
        options: OTHER_OPTIONS_OBJECT.business.vehicle,
        fullOptions: FULL_OPTIONS_VEHICLE.business,
        value: null,
    },
    home: {
        ...COMMON_REMOVABLE_PROPS,
        label: "Home Start",
        question:
            "If your vehicle breaks down at your work address, would you like us to help?",
        description:
            "Our basic cover begins when you're 1/4 mile from your registered office address - if you need us to attend at your doorstep, don't forget to add this.",
        descriptionCover:
            "Cover from your registered office address, cover starts 1/4 mile from your registered office address",
        options: OTHER_OPTIONS_OBJECT.business.home,
        optionsToggle: OPTIONS_TOGGLE.business.home,
    },
    personal: {
        ...COMMON_PERSONAL_PROPS,
        optionsToggle: [
            {
                label: 'No thanks',
                value: 0,
            },
            {
                label: 'Add Personal Cover',
                value: 1,
            },
        ],
    },
    nationwide: {
        ...COMMON_REMOVABLE_PROPS,
        ...COMMON_NATIONWIDE_PROPS,
    },
    local: {
        ...COMMON_LOCAL_PROPS,
    },
  
    onward: {
        ...COMMON_ONWARDS_PROPS,
        options: [
            {
                label: 'Yes',
                value: 1,
            },
            {
                label: 'No',
                value: 0,
            },
        ],
    },
    misfuel: {
        ...COMMON_MISFUEL_PROPS,
        options: [
            {
                label: 'Yes',
                value: 1,
            },
            {
                label: 'No',
                value: 0,
            },
        ],
    },
    excess: {
        ...COMMON_EXCESS_PROPS,
    },
    accident: {
        ...COMMON_ACCIDENT_PROPS,
    },
    unlimited: {
        ...COMMON_UNLIMITED_PROPS,
    },
    european: {
        ...COMMON_EUROPEAN_PROPS,
    },
    accident_plus: {
        ...COMMON_ACCIDENT_PLUS_PROPS,
    },
    parts_labour: {
        question: "Parts and Labour",
        description:
            "We'll cover up to 5 claims a year - each worth £350 with a £50 excess per claim.",
        label: "Parts and Labour",
        value: null,
        ...COMMON_PARTS_LABOUR_PROPS,
    },
    caravan_trailer: {
        ...COMMON_CARAVAN_TRAILER_PROPS,
    },
    key: { 
        ...COMMON_KEY_PROPS 
    },
    battery: { 
        ...COMMON_BATTERY_PROPS 
    },
    tyre: {
        question: "Tyre Assistance",
        description: "Our team are on hand to offer assistance if you damage or lose your keys, we'll recover you and your vehicle to your home address or to a local garage.",
        label: 'Tyre Assistance',
        ...COMMON_TYRE_PROPS,
    },
};
